module.exports = __webpack_public_path__ + "media/igor_home.536ad430.wav";